import { ApiUrl } from "../../ApiUrl"
export const fetchInitiatedByList = async () => {
    try {
      const response = await fetch(`${ApiUrl.apiurl}Message_Initiated/GetAllMessage_InitiatedList/`);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      if (data.message === "Success") {
        return data.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching initiated by list:", error);
      return [];
    }
  };
  